<template>
<!-- 企业管理-创建企业 -->
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <span class="title">企业名称:</span>

                    <el-input
                        v-model="search_data.name"
                        placeholder="请输入企业名称"
                        class="handle-input mr10"
                        @keyup.enter.native="searchStoreLists"
                    ></el-input>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchStoreLists">搜索</el-button>
            <el-button @click="add_isShow = !add_isShow">创建企业</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header" @row-click="rowContextmenu">
            <el-table-column label="企业名称" prop="name" min-width="130"> </el-table-column>

            <el-table-column label="管理员" prop="admin_name" min-width="100"> </el-table-column>

            <el-table-column label="联系电话" prop="admin_phone" min-width="180"> </el-table-column>

            <el-table-column prop="" label="合同" min-width="120">
                <template slot-scope="scope">
                    <el-button
                        type="primary"
                        @click.stop="
                            heTong_isShow = !heTong_isShow;
                            heTong = scope.row;
                        "
                        >查看</el-button
                    >
                </template></el-table-column
            >

            <el-table-column label="上架">
                <template slot-scope="scope">
                    <div @click.stop="editStoreStatus(scope.row)">
                        <el-switch v-model="scope.row.status" active-value="1" inactive-value="0"> </el-switch>
                    </div>
                </template>
            </el-table-column>

            <el-table-column width="260" label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" @click.stop="editQiye(scope.row)">编辑</el-button>
                    <el-button
                        type="primary"
                        @click.stop="
                            detail_isShow = !detail_isShow;
                            store_code = scope.row.store_code;
                            menDianName = scope.row.name;
                        "
                        >查看企业门店</el-button
                    >
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
        <!-- 查看合同 -->
        <getStoreContractDetails :isShow="heTong_isShow" :data="heTong" :name="heTongName"></getStoreContractDetails>
        <!-- 查看门店 -->
        <storeAdminLists :isShow="detail_isShow" :data="store_code" :name="menDianName"></storeAdminLists>

        <!-- 创建企业组件 -->
        <addStoreSubmit :isShow="add_isShow" @onSubmit="storeLists"></addStoreSubmit>

        <!-- 编辑组件 -->
        <editStoreSubmit :isShow="edit_isShow" :data="store_details" @onSubmit="storeLists"></editStoreSubmit>
    </div>
</template>

<script>
var _this;
import addStoreSubmit from './addStoreSubmit.vue';
import getStoreContractDetails from './getStoreContractDetails.vue';
import storeAdminLists from './storeAdminLists.vue';
import editStoreSubmit from './editStoreSubmit.vue';
export default {
    components: {
        addStoreSubmit,
        getStoreContractDetails,
        storeAdminLists,
        editStoreSubmit
    },
    data() {
        return {
            store_code: '',
            store_details: '',
            heTong: '',
            heTongName: '',
            menDianName: '',

            // 添加信息组件开关
            add_isShow: false,

            // 编辑信息组件开关
            edit_isShow: false,
            // 查看合同
            heTong_isShow: false,
            // 列表查看
            detail_isShow: false,

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                name: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.storeLists();
    },

    methods: {
        editQiye(val) {

            _this.edit_isShow = !_this.edit_isShow;
            _this.store_details = val;
        },
        // 表格单击事件
        rowContextmenu(row, column, event) {
            _this.store_code = row.store_code;
            _this.menDianName = row.name;

            _this.detail_isShow = !_this.detail_isShow;
        },
        editStoreStatus(val) {
            _this
                .$post('/store/editStoreStatus', { store_code: val.store_code, status: val.status })
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.storeLists();
                })
                .catch((err) => {});
        },

        searchStoreLists() {
            _this.search_data.page = 1;
            _this.storeLists();
        },

        // 搜索用户管理列表
        storeLists() {
            _this
                .$post('/store/storeLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.storeLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
